export default "__VITE_ASSET__8f556899__"